import gql from 'graphql-tag';

const getAccountMarketingMaterials = gql`
  query accountMarketingMaterial($id: RecordID!) {
    accountMarketingMaterial(id: $id) {
      id
      type
      pdf_url
      image_url
      account {
        id
        username
        organization_name
        logo_image {
          id
          url
        }
      }
      album_folder {
        id
        name
        join_code
        is_web_gallery
        onboarding_short_url
        is_demo
        album_price_mode
        album_type
        album_subtype
        photo_sharing_mode
        joins_enabled
        picture_day_enabled
        has_charity
        has_video_album
        search_subscription_credits_joins_enabled
        auto_contributor_share_url
        purchased_event {
          id
          features {
            white_label_marketing_prints_enabled
          }
        }
        price {
          value
        }
      }
    }
  }
`;

export default getAccountMarketingMaterials;
